__turbopack_context__.v({
  "bodyText": "promos-module-scss-module__rrwtPa__bodyText",
  "copy": "promos-module-scss-module__rrwtPa__copy",
  "copyWrapper": "promos-module-scss-module__rrwtPa__copyWrapper",
  "figure": "promos-module-scss-module__rrwtPa__figure",
  "hasBorder": "promos-module-scss-module__rrwtPa__hasBorder",
  "imageWrapper": "promos-module-scss-module__rrwtPa__imageWrapper",
  "promo": "promos-module-scss-module__rrwtPa__promo",
  "promoContainer": "promos-module-scss-module__rrwtPa__promoContainer",
  "reversed": "promos-module-scss-module__rrwtPa__reversed",
  "title": "promos-module-scss-module__rrwtPa__title",
});
